import React from "react";

export default function ErrorDisplay(props) {
    let errorClass = '';
    if(props.error === 'yes')
    {
        errorClass = 'invalid-feedback';
    } else if (props.error === 'valid') {
        errorClass = 'valid-feedback';
    }
    return (
        <div className={errorClass}>
            {props.errorMessage}
        </div>
    );
}
